import { connect } from "react-redux";

import App from "../components/app";

const mapStateToProps = (state) => ({
  currentContractor:
    state.home?.currentContractor ?? state.currentContractor ?? state,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(App);
